import { createStore } from 'redux' // 引入redux createStore、中间件及compose 
import reducer from './reducer';

const Store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default Store;

